import { UnistylesRuntime } from "react-native-unistyles";
import { View, Text, Card } from "@src/components";
import { Icon } from "@src/components/Icon";

export function NothingApplied() {
  const theme = UnistylesRuntime.getTheme();

  return (
    <View px="5xl" pt="4xl" bg="background">
      <Card>
        <View flexDirection="row" justifyContent="space-between" alignItems="center">
          <View flex={1} flexDirection="row" alignItems="center" gap="md">
            <Icon name="clockOutline" size={20} color={theme.colors.text} />
            <View flex={1}>
              <Text textStyle="sm/medium" mb="xs">
                Applying changes
              </Text>
              <Text textStyle="sm/regular" color="textMuted" mb="xs">
                We&apos;re applying your camera&apos;s first alarm configuration.
              </Text>
            </View>
          </View>
        </View>
      </Card>
    </View>
  );
}
